import React, { useEffect, useState } from "react";
import "./Dashboard.css";

const Dashboard = () => {
  const [counts, setCounts] = useState({
    users: 0,
    companies: 0,
    currencies: 0,
  });

  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const [userModalOpen, setUserModalOpen] = useState(false);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [currencyModalOpen, setCurrencyModalOpen] = useState(false);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [usersRes, companiesRes, currenciesRes] = await Promise.all([
          fetch("/api/admin/users"),
          fetch("/api/admin/companies"),
          fetch("/api/admin/currencies"),
        ]);

        const usersData = await usersRes.json();
        const companiesData = await companiesRes.json();
        const currenciesData = await currenciesRes.json();

        setCounts({
          users: usersData.count || 0,
          companies: companiesData.count || 0,
          currencies: currenciesData.count || 0,
        });
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    fetchCounts();
  }, []);

  const handleViewUsers = async () => {
    try {
      const response = await fetch("/api/admin/users");
      const data = await response.json();
      setUsers(data.users || []);
      setUserModalOpen(true);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleViewCompanies = async () => {
    try {
      const response = await fetch("/api/admin/companies");
      const data = await response.json();
      setCompanies(data.companies || []);
      setCompanyModalOpen(true);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const handleViewCurrencies = async () => {
    try {
      const response = await fetch("/api/admin/currencies");
      const data = await response.json();
      setCurrencies(data.currencies || []);
      setCurrencyModalOpen(true);
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  };

  return (
    <div className="dashboard-container">
      <h2 className="dashboard-title">Dashboard</h2>
      <div className="cards">
        <div className="card card-users">
          <h3>Users</h3>
          <p className="count">{counts.users}</p>
          <button onClick={handleViewUsers}>View Users</button>
        </div>
        <div className="card card-companies">
          <h3>Brokers</h3>
          <p className="count">{counts.companies}</p>
          <button onClick={handleViewCompanies}>View Companies</button>
        </div>
        <div className="card card-currency">
          <h3>Currency</h3>
          <p className="count">{counts.currencies}</p>
          <button onClick={handleViewCurrencies}>View Currency</button>
        </div>
      </div>

      {/* Users Modal */}
      {userModalOpen && (
        <div className="modal-overlay fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h3>All Users</h3>
              <button
                className="close-btn"
                onClick={() => setUserModalOpen(false)}
              >
                X
              </button>
            </div>
            <table className="user-table">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Mobile Number</th>
                </tr>
              </thead>
              <tbody>
                {users?.map((user, index) => (
                  <tr key={index}>
                    <td>{user.username}</td>
                    <td>{user.email}</td>
                    <td>{user.mobilenumber || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Companies Modal */}
      {companyModalOpen && (
        <div className="modal-overlay fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h3>All Brokers</h3>
              <button
                className="close-btn"
                onClick={() => setCompanyModalOpen(false)}
              >
                X
              </button>
            </div>
            <table className="user-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company, index) => (
                  <tr key={index}>
                    <td>
                      {" "}
                      <img src={company.logo} alt="Logo" width={30} />
                    </td>
                    <td>{company.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Currencies Modal */}
      {currencyModalOpen && (
        <div className="modal-overlay fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h3>All Currencies</h3>
              <button
                className="close-btn"
                onClick={() => setCurrencyModalOpen(false)}
              >
                X
              </button>
            </div>
            <table className="user-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Symbol</th>
                </tr>
              </thead>
              <tbody>
                {currencies.map((currency, index) => (
                  <tr key={index}>
                    <td>{currency.code}</td>
                    <td>{currency.name}</td>
                    <td>
                      {" "}
                      <img src={currency.symbol} alt="Logo" width={40} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
